module.exports = __webpack_public_path__ + "static/media/logo.15510b40.png";